import React, { type ComponentProps, ReactNode } from 'react';
import { GenericAd } from '@adverts/components/GenericAd.component';
import { ADVERT_FORMAT_ID } from './Adverts.contants';

export function insertAdvertInArray(
  inputArray: ReactNode[],
  position: number,
  maxSize: number,
  formatId: ADVERT_FORMAT_ID,
  advertProps?: Omit<ComponentProps<typeof GenericAd>, 'formatId'>
): ReactNode[] {
  const ad = <GenericAd formatId={formatId} key={`ad-${position}-${formatId}`} {...advertProps} />;

  const out = inputArray.slice();
  out.splice(position, 0, ad);
  return out.slice(0, maxSize);
}
